import { cloneDeep } from 'lodash';
import { create } from 'zustand';
import { getState, useState } from '@/framework';
import { IExportState, StateType } from '@/version-types';

export interface IGridInfoProps {
    rows: {
        value: number;
        visible: boolean;
    };
    columns: {
        value: number;
        visible: boolean;
    };
    grid: {
        value: number;
        visible: boolean;
    };
    rowSpace: number;
    columnSpace: number;
    leftRightSpace: {
        value: number;
        visible: boolean;
    };
    topBottomSpace: {
        value: number;
        visible: boolean;
    };
    innerRightSpace: {
        value: number;
        visible: boolean;
    };
    innerBottomSpace: {
        value: number;
        visible: boolean;
    };
}

/** 状态 */
export interface IState {
    showGridLineOperate: boolean;
    gridInfo: IGridInfoProps;
}

/** 动作 */
export interface IAction {
    setShowGridLineOperate: (showGridLineOperate: boolean) => void;
    setGridInfo: (gridInfo: IGridInfoProps) => void;
}

/** 存储类型 */
export interface IStore extends IState, IAction {}

export const DefaultGridInfo = {
    grid: { value: 8, visible: false },
    rows: { value: 6, visible: false },
    columns: { value: 12, visible: false },
    rowSpace: 24,
    columnSpace: 24,
    leftRightSpace: {
        value: 96,
        visible: false,
    },
    topBottomSpace: {
        value: 96,
        visible: false,
    },
    innerRightSpace: {
        value: 0,
        visible: false,
    },
    innerBottomSpace: {
        value: 0,
        visible: false,
    },
} as IGridInfoProps;

/** 初始化状态 */
function getInitialState(): IState {
    return {
        showGridLineOperate: false,
        gridInfo: cloneDeep(DefaultGridInfo),
    };
}

/** 创建存储 */
const createStore = (identity: string) => {
    const store = create<IStore>((set, get) => ({
        ...getInitialState(),
        setShowGridLineOperate: (showGridLineOperate) => {
            set({ showGridLineOperate });
        },
        setGridInfo: (gridInfo) => {
            set({ gridInfo });
        },
        destroy() {
            set(getInitialState());
        },
    }));

    return store;
};

/** 存储名称 */
const name = 'stage-grid-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取存储 */
export const useStageGridStore = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getStageGridStore = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

const exportState: IExportState = {
    name,
    createState: createStore,
};

export default exportState;
